import { render, staticRenderFns } from "./ConsumptionReasonPage.vue?vue&type=template&id=77d5cd2a&"
import script from "./ConsumptionReasonPage.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionReasonPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports